const LEVEL_LABELS = ["入門", "N5", "N4", "N3", "N2", "N1"];

/** 平均レベル（数値 0〜5 またはラベル）を表示用にする */
export function levelLabel(v: unknown): string {
  if (v == null || v === "") return "—";
  if (typeof v === "string" && Number.isNaN(Number(v))) return v;
  const n = Number(v);
  const idx = Math.max(0, Math.min(LEVEL_LABELS.length - 1, Math.round(n)));
  const base = LEVEL_LABELS[idx];
  return Number.isInteger(n) ? base : `${base}（${n.toFixed(1)}）`;
}

/** D1 の "YYYY-MM-DD HH:MM:SS"（UTC）または ISO を Date にする */
export function parseDbDate(s: string): Date {
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s.replace(" ", "T")}Z`);
}

export function shortDate(s: string | null | undefined): string {
  if (!s) return "—";
  const d = parseDbDate(s);
  if (Number.isNaN(d.getTime())) return s;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}/${m}/${day}`;
}

export function shortDateTime(s: string): string {
  const d = parseDbDate(s);
  if (Number.isNaN(d.getTime())) return s;
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${m}/${day} ${hh}:${mm}`;
}

/** CSV 登録の学習者の埋め草メール（<login_id>@login.invalid）は画面に出さない */
export function visibleEmail(email: string | null | undefined): string {
  if (!email || email.endsWith("@login.invalid")) return "";
  return email;
}
